import { createStore } from 'vuex'

import { BrelagModule } from '@/store/BrelagStore'
import { SettingsModule } from '@/store/SettingsStore'

import { EventFeedModule } from './EventFeedStore'
import { GlobalModule } from './GlobalStore'

const store = createStore({
  modules: {
    global: new GlobalModule<any>(),
    eventFeed: new EventFeedModule<any>(),
    brelag: new BrelagModule<any>(),
    settings: new SettingsModule<any>(),
  },
})

export default store

export const initialStateCopy = JSON.parse(JSON.stringify(store.state))
